import styled, { css } from 'styled-components';
import { Checkbox } from '@mui/material';
import { HelpOutline as HelpIcon } from '@mui/icons-material';

import colors from '../../../styles/colors';

const Container = styled.div`
  display: flex;
  width: 100%;
  min-height: 540px;
  /*
    Allow the table to shrink when the right chat panel expands.
    The DataGrid can handle horizontal scrolling internally when columns exceed width.
  */
  min-width: 0;
  height: 70vh;
`;

const DataGridContainer = styled.div`
  flex-basis: 100%;
  min-width: 0;
  .MuiDataGrid-row {
    align-items: center;
    .MuiDataGrid-cell {
      .MuiBadge-badge{
        white-space: nowrap;
      }
    }
  } 
`;

const StyledList = styled.ul`
  width: 100%;
  height: 100%;
  line-height: 18px;
  margin-block: unset;
  margin-inline: unset;
  padding-inline: unset;
  padding: 8px 20px;
  overflow-y: auto;
`;

const commonCellStyles = css`
  display: flex;
  height: 100%;
  width: 100%;
  padding: 8px;
  word-wrap: break-word;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 18px;
  text-transform: capitalize;
`;

const CellContainer = styled.div`
  ${commonCellStyles};
`;

const StyledImage = styled.img`
  width: 100%;
  height: auto;
  aspect-ratio: 1;
  object-fit: scale-down;
`;

const StyledCheckBox = styled(Checkbox)`
  padding: 5px;
`;

const ProductCellContainer = styled.div`
  ${commonCellStyles};
  align-items: center;
  padding-right: 2px;
  white-space: nowrap;
  overflow: hidden;
`;

const ProductName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ChipContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  padding: 4px;
`;

const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
  background-color: ${colors.shades.gamma5};
`;

const StyledHelpIcon = styled(HelpIcon)`
  width: 15px;
  height: 15px;
`;

export {
  Container,
  DataGridContainer,
  StyledList,
  StyledImage,
  CellContainer,
  ProductCellContainer,
  ProductName,
  StyledCheckBox,
  ChipContainer,
  InfoRow,
  StyledHelpIcon,
};
